<template>
    <div
        data-interface-target="game-login-prompt"
        :class="$style.container"
    >
        <GhostIconButton
            icon="close"
            size="s"
            color="white"
            :class="$style.close_button_override"
            interfaceTarget="login-prompt-close-button"
            @click="emit('close')"
        />
        <img
            :class="$style.icon"
            :src="Icon"
            alt="Save Icon"
        />
        <!-- eslint-disable vue/no-v-html vue/no-v-text-v-html-on-component-->
        <Typography
            size="s"
            type="paragraph"
            :class="$style.label"
            v-html="$tr('saveProgressPrompt.label')"
        />
        <!-- eslint-enable vue/no-v-html vue/no-v-text-v-html-on-component -->
        <Button
            color="lime"
            :class="$style.button_override"
            interfaceTarget="login-prompt-login-button"
            :label="$tr('saveProgressPrompt.login_button')"
            @click="emit('login')"
        />
    </div>
</template>

<script setup lang="ts">
import Button from '@/components_new/Buttons/Button.vue'
import GhostIconButton from '@/components_new/Buttons/GhostIconButton.vue'
import Typography from '@/components_new/Typography.vue'

import Icon from './images/save.webp'

const emit = defineEmits<{ close: []; login: [] }>()
</script>

<style module>
.container {
    position: absolute;
    top: 40px;
    left: 50%;
    transform: translateX(-50%);
    display: grid;
    grid-template-columns: 64px 1fr;
    grid-template-areas:
        'icon label'
        'button button';
    gap: 8px 16px;
    padding: 12px;
    border-radius: 16px;
    background: rgba(29, 28, 38, 0.8);
    backdrop-filter: blur(calc(var(--16, 16px) / 2));
    width: 280px;
    z-index: 1;
}

.close_button_override {
    position: absolute;
    top: 4px;
    right: 4px;
}

.icon {
    grid-area: icon;
    height: 64px;
    width: 64px;
}

.label {
    grid-area: label;
    align-self: center;
}

.button_override {
    grid-area: button;
}
</style>
